import styled from 'foundations-theming/utils';
import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { AVATAR_SIZES, SOCIAL_MAP } from '../../Constants';
import { jsx as _jsx } from "react/jsx-runtime";
// em is used for IconCircle spacing which is a relative unit that we can
// scale with the size of the avatar with font-size.
// offset is used to offset the social badge to the right of the avatar.
const SOCIAL_BADGE_PADDING_SIZES = {
  xxs: '50',
  xs: '50',
  sm: '50',
  md: '100',
  lg: '100',
  xl: '200',
  responsive: '0'
};
const SocialBadgeWrapper = styled.div.withConfig({
  displayName: "SocialBadge__SocialBadgeWrapper",
  componentId: "i8c70h-0"
})(["", ""], ({
  fontSize
}) => ({
  fontSize,
  position: 'absolute',
  right: '-16%',
  bottom: '-1%'
}));
const SocialBadge = ({
  socialNetwork,
  size
}) => {
  const {
    icon,
    color
  } = SOCIAL_MAP[socialNetwork];
  if (!icon || !color) {
    return null;
  }
  const padding = SOCIAL_BADGE_PADDING_SIZES[size];
  const fontSize = size === 'responsive' ? 0 : AVATAR_SIZES[size] * 0.3;
  return /*#__PURE__*/_jsx(SocialBadgeWrapper, {
    fontSize: fontSize,
    children: /*#__PURE__*/_jsx(IconCircle, {
      display: "flex",
      backgroundColor: color,
      icon: icon,
      borderWidth: "0",
      color: "icon-core-on-fill-default",
      size: "inherit",
      "data-test-id": "avatar-social-badge",
      "data-avatar-name": socialNetwork,
      padding: padding,
      margin: "0"
    })
  });
};
export default SocialBadge;